// src/components/achievement/YouTubeModal.tsx
import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export type ModalProps = {
  title: string;
  url: string;
  onClose: () => void;
};

const getYoutubeVideoId = (url: string): string | null => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

const getYoutubeEmbedUrl = (url: string): string => {
  const videoId = getYoutubeVideoId(url);
  return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
};

const YouTubeModal: React.FC<ModalProps> = ({ title, url, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-900 bg-opacity-90 flex items-center justify-center p-4">
      <div className="relative w-full max-w-4xl">
        <button
          onClick={onClose}
          className="absolute -top-10 right-0 text-white hover:text-destiny-gold"
        >
          <XMarkIcon className="h-8 w-8" />
        </button>

        <h3 className="text-white text-xl font-bold mb-4">{title}</h3>

        <div className="relative pb-[56.25%] h-0 overflow-hidden rounded-lg shadow-lg">
          <iframe
            src={getYoutubeEmbedUrl(url)}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default YouTubeModal;
